import AuthFlowerPortal from "./AuthFlowerPortal";

export default function Login() {
  return <AuthFlowerPortal initialPanel="login" />;
}
